<template>
  <AuthLayout :mode="mode">
    <Section
      heading="Welcome to the ITAD Association <br class='sm:hidden' /> Members Area"
      description="This is your space with all the tools and resources you need <br class='sm:hidden' /> to work efficiently in the IT equipment trading industry."
      :mode="mode"
    />
    
    <!-- Quick Search Box -->
    <div class="mb-8">
      <AppCard :mode="mode" title="Quick Search" :isSmallTitle="true">
        <template #body>
          <div class="flex gap-3 md:flex-col">
            <AppInput
              :mode="mode"
              id="quickSearch"
              title="Search equipment, listings, or emails"
              placeholder="Enter keyword to search..."
              v-model="quickSearchTerm"
              @keyup.enter="goToSearch"
              parentClasses="flex-1"
            />
            <div class="flex items-end">
              <AppButton
                title="Search"
                :isDisabled="!quickSearchTerm"
                @action="goToSearch"
              />
            </div>
          </div>
        </template>
      </AppCard>
    </div>
    
    <div class="grid grid-cols-2 gap-6 sm:grid-cols-1">
      <IconCard
        v-for="(item, key) in items"
        :key="key"
        :mode="mode"
        :item="item"
      />
    </div>
  </AuthLayout>
</template>

<script>
import { Settings, Users } from "lucide-vue-next";
import Section from "@C/Common/Section.vue";
import IconCard from "@C/Common/IconCard.vue";
import AuthLayout from "@A/AuthLayout.vue";
import AppCard from "@C/Common/AppCard.vue";
import AppInput from "@C/Form/AppInput.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "Home",
  components: {
    AuthLayout,
    Settings,
    Users,
    Section,
    IconCard,
    AppCard,
    AppInput,
    AppButton,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      quickSearchTerm: "",
      items: [
        {
          icon: Settings,
          title: "For Equipment Trading Network (ETN) Members",
          subTitle: "As an ETN subscriber, you have <br /> access to:",
          list: [
            "Tools for buying and selling equipment.",
            "Features to simplify your trading process.",
          ],
          link: "/members/trading-network",
          linkText: "Trading Network",
        },
        {
          icon: Users,
          title: "For ITAD Association Members",
          subTitle: "As a member of ITAD Association, <br /> you get:",
          list: [
            "Business support tools.",
            "The latest updates and industry news.",
          ],
          link: "https://www.itadassociation.com",
          linkText: "ITAD Association Home",
        },
      ],
    };
  },
  methods: {
    goToSearch() {
      if (this.quickSearchTerm.trim()) {
        this.$router.push({
          name: "search",
          query: { q: this.quickSearchTerm }
        });
      }
    },
  },
};
</script>
